interface FamilyRelationship {
  familyRelation: 'EMPLOYEE' | 'SPOUSE' | 'CHILD';
  memberType: number;
}

export const getFamilyRelationshipByCode = (code: string, memberType: string): FamilyRelationship | undefined => {
  const memberTypeNumber = parseInt(memberType);
  switch (code) {
    case 'E':
      return { familyRelation: 'EMPLOYEE', memberType: memberTypeNumber };
    case 'S':
      return { familyRelation: 'SPOUSE', memberType: memberTypeNumber };
    case 'C':
      return { familyRelation: 'CHILD', memberType: memberTypeNumber };
    default:
      return;
  }
};
